// 本模块为首页视图相关逻辑及状态,主要用来做页面传参
import successfulCases from '@/api/successfulCases.js'

const state = {
    wapCasesList: [],
    casesList: [],
    casesPageTotal: 1,
    casesLastPage: 1,
    casesCategory:[
        {
            id:2,
            name:'智慧农贸市场',
            english_name:'Wisdom Agr Trade Market',
        },
        {
            id:1,
            name:'智慧农批市场',
            english_name:'Wisdom Agr Wholesale Market',
        }
    ],
    casesDetails: {},
}

const getters = {
    wapCasesList(state) {
        return state.wapCasesList
    },
    casesList(state) {
        return state.casesList
    },
    casesPageTotal(state) {
        return state.casesPageTotal
    },
    casesLastPage(state) {
        return state.casesLastPage
    },
    casesCategory(state) {
        return state.casesCategory
    },
    casesDetails(state) {
        return state.casesDetails
    },
}

const mutations = {
    setCaseState(state, { key, value }) {
        state[key] = value
    },
}

const actions = {
    getCasesList({ state, dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            successfulCases.successfulCases({
                per_page: data.per_page,
                page: data.page,
                category_id:data.category_id,//1农批 2农贸
            }).then((res) => {
                let code = res.data.code;
                if (code == 200) {
                    commit('setCaseState', {
                        key: 'casesList',
                        value: res.data.data.data
                    }),
                    commit('setCaseState', {
                        key: 'casesPageTotal',
                        value: res.data.data.total
                    }),
                    commit('setCaseState', {
                        key: 'casesLastPage',
                        value: res.data.data.last_page
                    })
                    let list = [];
                    if (data.page === 1) {
                        list = res.data.data.data
                    } else {
                        list = state.wapCasesList.concat(res.data.data.data);
                    }
                    commit('setCaseState', {
                        key: 'wapCasesList',
                        value: list
                    })
                    resolve(res)
                }
            }).catch((error) => {
                reject(error)
            });
        })
    },
    getCasesDetails({ state, dispatch, commit }, data) {
        return new Promise((resolve, reject) => {
            commit('setCaseState', {
                key: 'casesDetails',
                value: {}
            })
            successfulCases.successfulCaseDetails(data.id).then((res) => {
                let code = res.data.code;
                if (code == 200) {
                    commit('setCaseState', {
                        key: 'casesDetails',
                        value: res.data.data
                    })
                }
                resolve(res)
            }).catch((error) => {
                reject(error)
            });
        })
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/successfulCases.js